<template>
   <div>
    <v-container fluid>
        <v-card>
            <v-card-title class="d-flex justify-space-between">
                <span>Configure Curriculum Kit 2 amount</span>
                <v-btn
                  :to="{name:'amountconfigurationList'}"
                  class="mr-2"
                  small
                  dense
                  elevation="0"
                >
                    <v-icon left>mdi-chevron-left</v-icon>back
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="3" lg="3" xs="12">
                        <v-autocomplete
                            name="academic-year"
                            v-model="selectedAYID"
                            required
                            item-value="id"
                            :items="academicYears"
                            key="id"
                            item-text="academicYear"
                            :disabled="this.id ? true : false"
                        >
                            <template v-slot:label>
                                Select Academic Year <span class="error--text">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="4" md="3" lg="3" xs="12">
                      <div class="control" style="display: flex; align-items: center;">
                        <v-checkbox
                          v-model="isHeavyWinter"
                          label="Is Heavy Winter Jacket Applicable"
                          class="mr-3 label"
                          :disabled="this.id ? true : false"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" lg="3" xs="12" v-if="!isHeavyWinter">
                        <v-autocomplete
                            key="id"
                            :items="zones"
                            v-model="selectedZones"
                            item-text="name"
                            item-value="id"
                            :disabled="this.id ? true : false"
                        >
                        <template v-slot:label>
                            Select Zone <span class="error--text">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" lg="3" xs="12">
                        <v-text-field
                            v-model="amount"
                            type="number"
                            @keypress="validateAmont($event)">
                        >
                            <template v-slot:label>
                                Enter Amount <span class="error--text">*</span>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col class="d-flex align-end pb-8" cols="12" md="3" lg="3" xs="12">
                        <v-btn @click="createWowKit2ConfigurationAmount()" class="mr-4" dense small color="accent" elevation="0">
                            <v-icon small>mdi-content-save</v-icon> Save
                        </v-btn>
                        <v-btn @click="clearConfiguratinForm(edit)" dense small elevation="0">
                            <v-icon small>mdi-close</v-icon> Clear
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>

    <v-container fluid v-if="rejectReason.length > 0">
      <v-card>
        <v-card-title class="d-flex justify-space-between">
            <span>Rejection Reasons</span>
        </v-card-title>

        <v-card-text style="padding-right: 16px !important;" class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <table
            height="100px"
          >
              <thead>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in rejectReason"
                  :key="item.name"
                  :class="index === 0 ? 'white-row' : 'grey-row'"

                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.remark }}</td>
                </tr>
              </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-container>

  </div>
</template>
<script>
import constants from '@/utils/constants'
// import Utils from '@/utils'
export default {
  name: 'configurecurriculumkit2amount',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    edit: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      isHeavyWinter: false,
      academicYears: [],
      zones: [],
      selectedAYID: null,
      selectedZones: null,
      amount: null,
      rejectReason: [],
      formattedRejectReason: ''
    }
  },
  async created () {
    await this.getAcademicYearsList()
    await this.getZoneDetails()
    if (this.id) {
      this.getSingleCurriculumKit2AmountConfiguration(this.id)
      this.getRejectReason(this.id)
    }
  },
  methods: {
    getSingleCurriculumKit2AmountConfiguration: async function (selectedId) {
      await http
        .post(`${constants.API_URL}/api/kit2/get-kit2-configuration`, { id: selectedId })
        .then((res) => {
          if (res.status === 200 && res.data.length === 1) {
            if (res.data[0].status !== 'rejected') {
              this.$router.push({
                name: 'amountconfigurationList'
              })
            } else {
              this.selectedAYID = res.data[0].academicYearId
              this.selectedZones = res.data[0].zoneId
              this.isHeavyWinter = res.data[0].isHeavyWinter
              this.amount = res.data[0].amount
            }
          }
        })
        .catch((e) => {
          this.loadingComponent.close()
          const errorMessage =
              (e && e.response && e.response.data.message) || e.message
          return this.$dialog.message.error(errorMessage, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
    },
    getAcademicYearsList: async function () {
      try {
        let res = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = res.data.rows
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneDetails: async function () {
      try {
        let result = await http.get(
          `${constants.API_URL}/api/get/zones`
        )
        this.zones = result.data
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    validateAmont: function (event) {
      const keyCode = event.keyCode || event.which
      if (!((keyCode >= 48 && keyCode <= 57) || keyCode === 46)) {
        event.preventDefault()
      }
    },
    clearConfiguratinForm: function (comp) {
      if (comp === 'edit') {
        this.amount = null
      } else {
        this.selectedAYID = null
        this.selectedZones = null
        this.amount = null
      }
    },
    createWowKit2ConfigurationAmount: async function () {
      try {
        if (this.selectedAYID === null) {
          this.errMsg('Please select academic year')
          return
        }

        if (!this.isHeavyWinter && this.selectedZones === null) {
          this.errMsg('Please select zone')
          return
        }

        if (this.amount === null || this.amount === '') {
          this.errMsg('Please enter amount')
          return
        }

        if (this.amount <= 0) {
          this.errMsg('The entered amount should be greater than zero')
          return
        }

        let payload = {}
        payload.academicYearId = this.selectedAYID
        payload.isHeavyWinter = this.isHeavyWinter

        if (!this.isHeavyWinter) payload.zoneId = this.selectedZones

        payload.amount = this.amount
        let apiEndpoint = null
        if (this.id) {
          apiEndpoint = `${constants.API_URL}/api/kit2/update-kit2-configuration`
          payload.id = this.id
        } else {
          apiEndpoint = `${constants.API_URL}/api/kit2/add-kit2-configuration`
        }
        let res = await http.post(
          apiEndpoint,
          payload
        )
        if (res.status === 200 && res.data.status === 200) {
          this.okMsg(res.data.message)
          this.$router.push({
            name: 'amountconfigurationList'
          })
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    getRejectReason: async function (selectedId) {
      await http
        .post(`${constants.API_URL}/api/kit2/get-kit2-configuration-reasons`, { id: selectedId })
        .then((res) => {
          if (res.status === 200) {
            this.rejectReason = res.data
          }
        })
        .catch((e) => {
          this.loadingComponent.close()
          const errorMessage =
              (e && e.response && e.response.data.message) || e.message
          return this.$dialog.message.error(errorMessage, {
            position: 'top-right',
            color: 'error',
            timeout: 4000
          })
        })
    }
  }
}
</script>
<style>
.white-row {
  background-color: white;
}
.grey-row {
  background-color: #D3D3D3;
}
.white-row:hover,
.grey-row:hover {
  background-color: inherit;
  cursor:inherit;
}

/* Style table borders */
table {
    border-collapse: collapse;
    width: 100%;
}

th, td {
    /* border: 1px groove black;
    padding: 8px; */

    border: 1px solid black;
    padding: 10px;
}

th {
    background-color: #f2f2f2;
}

/* Disable hover effect for table rows */
table tr:hover {
    background-color: inherit;
    color: inherit;
}

</style>
